/* The journal: one entry per day, its numbers, the written entry and photos. */
.page {
  max-width: 920px;
  padding-bottom: var(--dimension-space-8);
}
.pad {
  padding: var(--dimension-space-4) var(--dimension-space-5);
}
.flat {
  margin: 0;
}
.muted {
  color: var(--color-text-secondary);
}
.faint {
  color: var(--color-text-tertiary);
}
.top {
  padding: var(--dimension-space-4) var(--dimension-space-5);
  border-bottom: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.notice {
  margin: 0;
  padding: var(--dimension-space-2) var(--dimension-space-5);
  background: var(--color-surface-sunken);
}
.days {
  margin: 0;
  padding: 0;
  list-style: none;
}
.day {
  display: grid;
  gap: var(--dimension-space-2);
  padding: var(--dimension-space-4) var(--dimension-space-5);
  border-bottom: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.dayHead {
  display: flex;
  align-items: center;
  gap: var(--dimension-space-2);
}
.tags,
.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--dimension-space-2);
}
.photos {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: var(--dimension-space-2);
  margin: 0;
  padding: 0;
  list-style: none;
}
.photos img {
  display: block;
  width: 100%;
  aspect-ratio: 1;
  object-fit: cover;
  border: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.pending {
  display: block;
  padding: var(--dimension-space-2);
  border: var(--dimension-line-hairline) dashed var(--color-border-control);
}
